import React from "react";
import playerImg from "../../img/player_default.png";
import { Player } from "../../interfaces/Player.Interface";
import "./PlayerGoalAssistCard.Styles.scss";

interface Props {
  player: Player;
  type: string;
}

export default function PlayerGoalAssistCard(props: Props) {
  const { player } = props;

  return (
    <div style={{ margin: 0, marginBottom: 40 }} className="col-xs-12 col-lg-4">
      <div className="row" style={{ margin: 10 }}>
        <div className="card-container col-xs-8 col-md-8">
          <img height={"380px"} src={player.imageUrl || playerImg} alt="" />
          <div className="gradient"></div>
          <div className="number-container">
            <div className="number">{player.jerseyNumber}</div>
          </div>
          <div className="name-container">
            <div className="first">{player.firstName.toUpperCase()}</div>
            <div className="last">{player.lastName.toUpperCase()}</div>
          </div>
        </div>
        <div className="info-container col-xs-4 col-md-4">
          <div>
            <div className="label">Position</div>
            <div className="position">{player.position.toUpperCase()}</div>
          </div>
          <div>
            <div className="label">Matches</div>
            <div className="number">{player.stats?.matches}</div>
          </div>
          <div>
            <div className="label">{props.type}</div>
            <div className="score">
              {props.type === "Goals"
                ? player.stats?.goals
                : player.stats?.assists}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
